import type { PLPProductCardSaleTag } from "./PLPProductCard.types";

const TRENDY_BG_HEX = "#ffeb34";

function normalizeHex(color: string): string {
  return color.replace(/\s/g, "").toLowerCase();
}

/** Figma TagsWeb style 2 (fishtail): `variant: trendy` or explicit trendy yellow bg. */
export function isPlpSaleTagTrendyShape(
  saleTag: PLPProductCardSaleTag
): boolean {
  if (saleTag.variant === "trendy") return true;
  const bg = saleTag.backgroundColor;
  if (typeof bg === "string" && normalizeHex(bg) === TRENDY_BG_HEX) return true;
  return false;
}

export const getSaleTagColors = (variant?: string) => {
  if (variant === "trendy") {
    return { bg: "#ffeb34", color: "#0d0d0d", icon: "fa-solid fa-bolt" };
  }
  return { bg: "#ff426f", color: "#ffffff", icon: "fa-regular fa-fire" };
};

/** Same rules as `PLPProductCard` overlay chip — use for PDP carousel or anywhere else. */
export function resolvePlpSaleTagStyle(saleTag: PLPProductCardSaleTag) {
  const defaults = getSaleTagColors(saleTag.variant);
  return {
    bg: saleTag.backgroundColor || defaults.bg,
    color: saleTag.color || defaults.color,
    icon: saleTag.iconName || defaults.icon,
  };
}
